import type { Shape } from '@mui/system/createTheme/shape'

/**
 * The base unit for controls — buttons, inputs, icon buttons. Cards and dialogs
 * scale up from it (see `MuiCard` / `MuiDialog` in components.tsx) so a
 * container never shares a corner radius with the controls sitting inside it.
 */
export const shape: Shape = {
  borderRadius: 10,
}

/** Fully rounded, for chips and progress tracks. */
export const PILL_RADIUS = 999
